import React, { useEffect } from "react";
import { Switch } from "react-router-dom";
import { SecureRoute } from "@okta/okta-react";
import { useIdleTimer } from "@tailormed/common-client/services/idleTimer";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { Layout } from "antd";

import { EnvironmentHeader } from "../component/EnvironmentHeader";
import { MainHeader } from "../component/MainHeader";
import { MainFooter } from "../component/MainFooter";
import { AssistanceProgramsView } from "../screen/AssistanceProgramsView";
import { handleReturnFromSleep, renewTokenTimer } from "@tailormed/common-client/services/auth";
import { selectUser, selectIDPConfig } from "../store/selector";
import { oktaConfig } from "../constant/config";

const SecuredRouterComponent = ({ user, idpConfig }) => {
  useIdleTimer(user, idpConfig, oktaConfig.loginURI);

  useEffect(async () => {
    await renewTokenTimer(user, idpConfig, oktaConfig.loginURI);
    await handleReturnFromSleep(user, idpConfig, oktaConfig.loginURI);
  }, []);

  return (
    <>
      <Layout>
        <EnvironmentHeader />
        <MainHeader />
        <Layout style={{ minHeight: "100vh", padding: "20px 70px", backgroundColor: "white" }}>
          <Switch>
            <SecureRoute path={"/"}>
              <AssistanceProgramsView />
            </SecureRoute>
          </Switch>
        </Layout>
        <MainFooter />
      </Layout>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  user: selectUser,
  idpConfig: selectIDPConfig
});

const SecuredRouter = connect(mapStateToProps, null)(SecuredRouterComponent);

export { SecuredRouter };
